import { func, object } from "prop-types";
import { useCallback, useEffect } from "react";

import FnrContainedIcon from "UI/FnrContainedIcon";
import { marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";

import Button from "../components/Button";
import { hoverTextKeys, useHoverTextKey } from "../toolbarStore";

const superSearchAssets = {
  css: ["supersearch/supersearch", "ui/checkbox/checkbox"],
  js: [
    "supersearch/supersearch",
    "ui/date",
    "colorpicker/colorpicker",
    "ui/checkbox/checkbox",
  ],
};

const ToggleOn = ({ setIsActive, toggleRef }) => {

  const handleClick = useCallback(() => {
    setIsActive(true);
  }, [setIsActive]);
  const [, setHoverTextKey] = useHoverTextKey();
  const isHoverFocused = useIsHoverFocused(toggleRef);

  const loadLegacySuperSearchAssets = () => {
    if (window.superSearchObj) return;

    window.fnReactBus.loadAssetsLegacy(superSearchAssets, "createSuperSearch");
  };

  useEffect(() => {
    if (isHoverFocused) setHoverTextKey(hoverTextKeys.superSearch);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHoverFocused, setHoverTextKey]);

  return (
    <Button
      ref={toggleRef}
      onClick={handleClick}
      onMouseEnter={loadLegacySuperSearchAssets}
      color={addOpacity(marketingColors.gray, 0.75)}
      data-cy="NavBar_SuperSearch_Toggle"
    >
      <FnrContainedIcon color="textLight" icon="search far" shadow />
    </Button>
  );
};

ToggleOn.propTypes = {
  setIsActive: func.isRequired,
  toggleRef: object,
};

export default ToggleOn;
